import { isEqual } from 'lodash';

export const objectDiff = function (src, dest) {
    const result = {};
    for (const key in dest) {
        if (typeof dest[key] === 'object' && dest[key] !== null && !Array.isArray(dest[key])) {
            const nestedObjectDiff = objectDiff(src[key], dest[key]);
            if (Object.keys(nestedObjectDiff).length !== 0) {
                result[key] = nestedObjectDiff;
            }
        } else if (Object.prototype.hasOwnProperty.call(src, key) && !isEqual(src[key], dest[key])) {
            result[key] = dest[key];
        }
    }
    return result;
};
